import React from 'react';
import { Phone } from 'lucide-react';
export function CTABand() {
  return <section className="bg-blue-600 py-16" data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-101">
        <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-6" data-id="element-102">
          Ready to stop cleaning and start swimming?
        </h2>
        <p className="text-blue-100 text-lg mb-10 max-w-2xl mx-auto" data-id="element-103">
          Spots on our weekly service route are filling up fast. Get a free
          quote today and let us handle the hard work.
        </p>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4" data-id="element-104">
          <button onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-white text-blue-600 hover:bg-slate-50 px-8 py-4 rounded-full font-bold text-lg transition-all shadow-lg w-full sm:w-auto" data-id="element-105">
            Get on the Route
          </button>
          <a href="tel:9034498879" className="bg-blue-700 hover:bg-blue-800 text-white px-8 py-4 rounded-full font-bold text-lg transition-all flex items-center justify-center gap-2 w-full sm:w-auto" data-id="element-106">
            <Phone className="w-5 h-5" data-id="element-107" />
            (903) 449-8879
          </a>
        </div>
      </div>
    </section>;
}